module.exports = __webpack_public_path__ + "img/Bingmo Shop.844f3a31.jpg";